import {
  InputAdornment,
  Stack,
  StackProps,
  TextField,
  styled,
} from "@mui/material";

import { useRef } from "react";
import Row from "../Row";
import { COLORS } from "constants/layout";
import { GreenButton } from "../Button";
import { useTranslation } from "hooks/useTranslation";
import { SearchIcon } from "Assets/icons";
import { Link } from "Components/link";
import { StyledAutocomplete } from "Components/input/Autocomplete.styles";
import { useSearchLogic } from "hooks/useSearchLogic";

const HeaderSearch = (props: StackProps) => {
  const t = useTranslation();
  const inputRef = useRef<HTMLInputElement>();
  
  const {
    selectedCategory,
    searchKeyword,
    searchCategories,
    searchCategoryLoading,
    getButtonHref,
    handleCategoryChange,
    handleInputChange,
    handleKeyDown,
  } = useSearchLogic();

  return (
    <StyledForm
      className="search-box"
      spacing={{ xs: 1, md: 2 }}
      direction={{ xs: "column", md: "row" }}
      {...props}
    >
      <StyledAutocomplete
        freeSolo
        value={selectedCategory}
        options={searchCategories}
        getOptionLabel={(option: any) => option.label || ""}
        loading={searchCategoryLoading}
        onChange={(e, newValue: any) => {
          handleCategoryChange(newValue);
        }}
        inputValue={searchKeyword}
        onInputChange={(e, newInputValue) => {
          handleInputChange(newInputValue);
        }}
        onKeyDown={handleKeyDown}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t("what_are_you_looking_for")}
            fullWidth
            inputRef={inputRef}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className="search-icon" />
                </InputAdornment>
              ),
            }}
          />
        )}
      />

      <Row spacing={1} className="buttons" sx={{ marginLeft: "8px!important" }}>
        <Link to={getButtonHref("buyer")}>
          <GreenButton className="search-btn">{t("find_buyers")}</GreenButton>
        </Link>

        <Link to={getButtonHref("supplier")}>
          <GreenButton className="search-btn">
            {t("find_suppliers")}
          </GreenButton>
        </Link>
      </Row>
    </StyledForm>
  );
};

export const StyledForm = styled(Stack)(({ theme }) => ({
  flex: 1,
  // maxWidth: 520,
  ".search-input": {
    maxWidth: 430,
  },
  ".MuiInputBase-root": {
    borderRadius: 8,
    "& input": {
      padding: "9px 16px",
      paddingLeft: 8,
      color: "#667085",
      fontSize: 14,
      lineHeight: "18pxx",
    },
    "& fieldset, &:hover fieldset, &.Mui-focused fieldset": {
      borderColor: COLORS.green[500],
    },
  },
  "& .MuiSelect-icon": {
    display: "none",
  },
  ".buttons": {
    button: {
      whiteSpace: "nowrap",
      fontWeight: 500,
    },
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    ".search-input": {
      maxWidth: "100%",
    },
    ".buttons": {
      a: {
        flex: 1,
      },
      button: {
        width: "100%",
        fontSize: 12,
      },
    },
  },
}));

export default HeaderSearch;
